<template>
<div>
    <div v-if="!loading">
        <v-row>
            <v-col>
                <h4 class="text-h4"> Display User </h4>
                <p class="text-subtitle-1">User Information</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(permissions.user.update)">
                <v-btn 
                    block
                    depressed
                    @click="handleEdit"
                    >
                    <v-icon small left>
                        mdi-pencil
                    </v-icon>
                    edit
                </v-btn>
            </v-col>
            <v-col cols="12" md="3" v-if="hasPermission(permissions.user.delete)">
                <v-btn
                    block
                    depressed
                    class= 'red--text'
                    @click="handleDelete"
                    :loading="deleteLoading"
                >
                    <v-icon left> 
                        mdi-trash-can     
                    </v-icon>
                    delete
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="user && user.must_change_password">
            <v-col>
                <v-alert class="mb-0" color="warning" text dense type="warning">Required to change password on next login</v-alert>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{{user.name}}</td>
                        </tr>
                        <tr>
                            <th>Username</th>
                            <td>{{user.username}}</td>
                        </tr>
                        <tr>
                            <th>Active</th>
                            <td>
                                <v-icon :color="user.inactive ? 'error' : 'success'">
                                    {{user.inactive ? 'mdi-account-cancel' : 'mdi-account-check'}}
                                </v-icon>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" v-if="hasPermission(permissions.user.update_role)">
                <v-autocomplete 
                    :label="$t('roles_and_permission')"
                    multiple
                    rounded
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    v-model="user.roles"
                    :loading="rolesLoading"
                    outlined
                    @change="submit"
                    chips
                >
                    <template v-slot:selection="data">
                        <v-chip
                            close
                            @click="handleClick(data.item)"
                            @click:close="remove(data.item)"
                        >
                        {{ data.item.name }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </div>
    <div v-else>
        <v-row>
            <v-col>
                <v-skeleton-loader type="heading" class="my-4"/>
                <v-skeleton-loader type="text" class="my-4"/>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="d-flex">
                <v-skeleton-loader type="button" class="my-4 me-4"/>
                <v-skeleton-loader type="button" class="my-4"/>
            </v-col>
        </v-row>
         <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
    </div>
</div>
</template>

<script>
import permissions from "./../../data/permissions"
import authorize from '@/utils/authorize'
import { mapActions } from 'vuex'
import PAlert from "./../../components/common/PAlert.vue"
import role from "./../../services/administration/role"
import user from "./../../services/administration/user"
import roleUser from "./../../services/administration/roleUser"
export default {
    components: {
        PAlert
    },
    data() {
        return {
            id: null,
            user: {
                roles: []
            },
            roles: [],
            rolesLoading: false,
            userRolesLoading: false,
            alert:{
                title: "Alert",
                value: false,
                content: "",
                callback: null
            },
            loading: false,
            updateRolesLoading: false,
            deleteLoading: false,
            permissions
        }
    },
    methods: {
        ...mapActions({
           snackbar: "ui/snackbar/show"
        }),
        getUser(id) {
            this.loading = true
            user.get(id).then((response) => {
                this.user = {
                    ...this.user,
                    ...response.data
                }
            }).finally(() => {
                this.loading = false
            })
        },
        getRoles() {
            this.rolesLoading = true
            role.index().then((response) => {
                this.roles = response.data
            }).finally(() => this.rolesLoading = false)
        },
        userRoles(id) {
            this.userRolesLoading = true
            user.roles(id).then((response) => {
                this.user = {
                    ...this.user,
                    roles: response.data.roles
                }
            }).finally(() => {
                this.userRolesLoading = false
            })
        },
        handleEdit() {
            this.$router.push({ name: "UserEdit"})
        },
        handleDelete(){
            this.alert = {
                ...this.alert,
                value: true,
                content: "Are you sure you want to delete?",
                callback: this.delete   
            }
        },
        delete() {
            this.deleteLoading = true
            user.remove(this.id).then(response => {
                this.snackbar({
                        text: response.data.message,
                        color: "success"
                    }) 
                this.$router.push({name: "usersList"})
            }).finally(() => {
                this.deleteLoading = false
            })
        },
        submit(){
        this.updateRolesLoading = true;
        user.updateRole(this.user)
            .then((response) => {
                this.snackbar({
                    text: response.data.message,
                    color: "success"
                })
            })
            .finally(() => {
                this.updateRolesLoading = false
            })
        },
        hasPermission(permission) {
            return authorize(permission);
        },
        handleClick(e) {
            this.$router.push({name: "RoleDisplay", params: { id: e.id } })
        },
        remove(item) {
            let {user_id, role_id} = {user_id: this.id, role_id: item.id}
            roleUser.remove(user_id, role_id).then(response => {
                this.snackbar({
                    text: response.data.message,
                    color: "success"
                })
                this.userRoles(this.id)
        })}
    },
    created() {
        this.id = this.$route.params.id
        this.getUser(this.id)
        this.getRoles()
        this.userRoles(this.id)
    }
}
</script>

<style>

</style>